<label class="mapfre switch-container">
  <div class="copy" [ngClass]="{ 'copy-right': copyRight, 'copy-left': copyLeft, 'copy-default': (copyLeft === undefined && copyRight === undefined)}">
    <span class="slider-text"><ng-content></ng-content></span>
  </div>
  <div class="switch fat">
    <input type="checkbox" (change)="switchValueOnOff($event)" 
    [checked]="setStatus" [disabled]="isDisabled">
    <span class="slider round" [ngClass]="{ 'disable-switch': isDisabled}"></span> 
  </div>
</label> 